export default {"src":"/_next/static/media/electric-charger.3e2fa0a6.svg","height":486,"width":486,"blurWidth":0,"blurHeight":0};